import React, { FC, useState, useEffect, useContext } from 'react';
import { Decision } from '../../entity/entity.types';
import { fetchEnterpriseTopDecisions } from '../enterprise.api';
import { EntityTopDecisions } from '../../entity/top-decisions/EntityTopDecisions';
import { EnterpriseContext } from './EnterpriseContext';

type Props = {
  allDecisionsLink: string;
};

export const EnterpriseTopDecisions: FC<Props> = ({ allDecisionsLink }) => {
  const [decisions, setDecisions] = useState<Decision[]>([]);
  const {
    enterpriseInfos: { siren, raisonSociale },
    experience: { decisionCount },
  } = useContext(EnterpriseContext);

  useEffect(() => {
    const fetchData = async () => {
      const decisionsFetched = await fetchEnterpriseTopDecisions(siren);
      setDecisions(decisionsFetched);
    };
    fetchData();
  }, [siren]);

  if (decisions.length === 0) {
    return null;
  }

  return (
    <EntityTopDecisions
      decisions={decisions}
      entityType="enterprise"
      allDecisionLink={allDecisionsLink}
      sources={{
        allDecisionsLink: 'read_all_enterprise_decisions_from_top_decisions',
        decisionLink: 'enterprise_top_decision',
      }}
      decisionCount={decisionCount}
      entityName={raisonSociale}
    />
  );
};
